import { render, staticRenderFns } from "./cmccTwoAuth.vue?vue&type=template&id=56c2d2fa&scoped=true&"
import script from "./cmccTwoAuth.vue?vue&type=script&lang=js&"
export * from "./cmccTwoAuth.vue?vue&type=script&lang=js&"
import style0 from "./cmccTwoAuth.vue?vue&type=style&index=0&id=56c2d2fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c2d2fa",
  null
  
)

export default component.exports